export default {
    requiredClient: 'אנא בחר לקוח',
    requiredOrder: 'אנא בחר הזמנה',
    requiredDate: 'אנא בחר תאריך',
    requiredTime: 'אנא בחר שעה',
    requiredCalendar: 'אנא בחר סוג לוח שנה',
}
